import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Insight from '../views/Insight.vue'
const routes = [
  {
    path: "/",
    alias: "/home",
    name: "homePage",
    component: Home,
  },
  {
    path: "/setup/:asgid",
    props: true,
    name: "setupPage",
    component: () => import("../views/Setup.vue"),
  },
  {
    path: "/dataset/:asgid",
    props: true,
    name: "dataQualityPage",
    component: () => import("../views/DataQ.vue"),
  },
  {
    path: "/insights/:asgid",
    props: true,
    name: "visualizationPage",
    component: Insight,
  },
  {
    path: "/slideMode/:asgid",
    props: true,
    name: "slidePage",
    component: () => import("../views/presentation.vue"),
  },
  {
    path: "/inquisight/:asgid",
    props: true,
    name: "inquisightPage",
    component: () => import("../views/inquisight.vue"),
  },
  {
    path: "/admin",
    props: true,
    name: "adminPage",
    component: () => import("../views/admin.vue"),
  },
  {
    path: "/approval/:settingID",
    props: true,
    name: "approvalPage",
    component: () => import("../views/approval.vue"),
  },
  {
    path: "/Page404",
    props: true,
    name: "missing404Page",
    component: () => import("../views/Page404.vue"),
  },
  {
    path: "/analytics",
    props: true,
    name: "analyticsPage",
    component: () => import("../views/analytics.vue"),
  },
  {
    path: "/TaggingPage/:asgid",
    props: true,
    name: "TaggingPage",
    component: () => import("../views/TaggingPage.vue"),
  },
  {
    path: "/appmHome/:asgid",
    props: true,
    name: "appmHome",
    component: () => import("../views/appm/appm-home.vue"),
  },
  {
    path: "/admin-appm",
    props: true,
    name: "adminAppm",
    component: () => import("../views/appm/admin-appm.vue"),
  },
  {
    path: "/pprDashboard/:asgid",
    props: true,
    name: "pprDashboard",
    component: () => import("../views/appm/ppr-dashboard.vue"),
  },
  {
    path: "/pprConsole/:asgid",
    props: true,
    name: "pprConsole",
    component: () => import("../views/appm/ppr-console.vue"),
  },
  {
    path: "/approvalPprConsole/:asgid",
    props: true,
    name: "approvalPprConsole",
    component: () => import("../views/appm/approval-ppr-console.vue"),
  },
  {
    path: "/viewPpr/:asgid",
    props: true,
    name: "viewPpr",
    component: () => import("../views/appm/view-ppr.vue"),
  },
  {
    path: "/historyAppm/:asgid",
    props: true,
    name: "historyAppm",
    component: () => import("../views/appm/history-appm.vue"),
  },
  {
    path: "/viewRule/:asgid",
    props: true,
    name: "viewRule",
    component: () => import("../views/appm/view-rules.vue"),
  },
  {
    path: "/view-rca/:asgid",
    props: true,
    name: "viewRca",
    component: () => import("../views/appm/view-rca.vue"),
  },
  {
    path: "/adminPprDashboard",
    props: true,
    name: "adminPprDashboard",
    component: () => import("../views/appm/admin-ppr-dashboard.vue"),
  },
  {
    path: "/appmUserPermissions/:asgid",
    props: true,
    name: "appmUserPermissions",
    component: () => import("../views/appm/user-permissions.vue"),
  },
  {
    path: "/ruleInput/:asgid",
    props: true,
    name: "ruleInput",
    component: () => import("../views/appm/rule-input.vue"),
  },
  {
    path: "/adminRulesAndTowers",
    props: true,
    name: "adminRulesAndTowers",
    component: () => import("../views/appm/admin-rules-towers.vue"),
  },
  {
    path: "/adminViewPpr",
    props: true,
    name: "adminViewPpr",
    component: () => import("../views/appm/admin-view-ppr.vue"),
  },
  {
    path: "/regex",
    props: true,
    name: "regex",
    component: () => import("../views/appm/validate-regex.vue"),
  },
  {
    path: "/my-work-place/:asgid",
    props: true,
    name: "myWorkPlace",
    component: () => import("../views/appm/my-work-place.vue"),
  },
  {
    path: "/workflow/:asgid",
    props: true,
    name: "workflow",
    component: () => import("../views/appm/workflow.vue"),
  },
  {
    path: "/admin-cis-weekly",
    props: true,
    name: "adminCisWeekly",
    component: () => import("../views/appm/admin-cis-weekly.vue"),
  },
  {
    path: "/admin-cmf",
    props: true,
    name: "adminCmf",
    component: () => import("../views/appm/admin-cmf.vue"),
  },
  {
    path: '/viewIncident/:asgid',
    name: 'viewIncident',
    component: () => import('../views/appm/view-incidents.vue'),
    props: true
  }
  // { path: '',props: true, name: '', component: () => import('') },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
const DEFAULT_TITLE = "OPSight";
router.beforeEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE;
});
export default router;
